// extracted by mini-css-extract-plugin
export var syllables = "K_cD";